module.exports = __webpack_public_path__ + "assets/8cc592f612561d0a2e3c597c598b807d.mp3";